/* eslint-disable @typescript-eslint/no-unused-vars */
// @ts-nocheck
/**
 * This file Copyright (c) 2010-2021 Magnolia International
 * Ltd.  (http://www.magnolia-cms.com). All rights reserved.
 *
 *
 * This program and the accompanying materials are made
 * available under the terms of the Magnolia Network Agreement
 * which accompanies this distribution, and is available at
 * http://www.magnolia-cms.com/mna.html
 *
 * Any modifications to this file must keep this entire header
 * intact.
 *
 */
// Auto generated file, don't change manually

import type {
  Asset,
  Rendition
} from '../../../../magnolia/lib/MagnoliaAsset';
import {
  transformNode,
  transformResults
} from '../../../../magnolia/lib/MagnoliaPropertyHelper';

export interface subjectOptionsStruct {
  key: string;
  label: string;
  recipientEmail ? : string;
}
export interface subjectOptionsStruct {
  key: string;
  label: string;
}
export interface switchableStruct {
  field: string;
  sideBySide ? : boolean;
  subjectOptions ? : Array < subjectOptionsStruct > ;
  salutationOptions: Array < any > ;
  btnLabel: string;
  salutationOptions: Array < any > ;
  subjectOptions ? : Array < subjectOptionsStruct > ;
  btnLabel: string;
}
export default interface Form {
  form1: any;
  form2: any;
  form3: any;
  switchable: switchableStruct;
  metadata ? : any;
}

export const Props = {
  form1: Object,
  form2: Object,
  form3: Object,
  switchable: Object as() => switchableStruct,
  metadata: Object,
}

export const WrapperProps = {
  form1: Object,
  form2: Object,
  form3: Object,
  switchable: Object as() => switchableStruct,
  metadata: Object,
}

export class FormBuilder {
  static build(props: any) {
    props = transformNode(JSON.parse(JSON.stringify(props)));
    class FormInstance implements Form {
      switchable: switchableStruct;
      form1: any;
      form2: any;
      form3: any;
      metadata ? : any;

      constructor(props: any) {
        Object.assign(this, props);

        if (this.switchable) {
          if (this.switchable.subjectOptions) {
            this.switchable.subjectOptions = Object.entries(this.switchable.subjectOptions)
              .filter((pair: [string, any]) => pair[0].match(new RegExp('^' + 'subjectOptions' + '[0123456789]+')))
              .map((pair: [string, any]) => ({
                ...pair[1]
              }));
          } else {
            this.switchable.subjectOptions = null as any;
          }
        }
        if (this.switchable) {
          if (this.switchable.subjectOptions) {
            this.switchable.subjectOptions = Object.entries(this.switchable.subjectOptions)
              .filter((pair: [string, any]) => pair[0].match(new RegExp('^' + 'subjectOptions' + '[0123456789]+')))
              .map((pair: [string, any]) => ({
                ...pair[1]
              }));
          } else {
            this.switchable.subjectOptions = null as any;
          }
        }
      }
    }
    return new FormInstance(props);
  }
}
